import { RouterConfigOptions } from '@angular/router';

/**
 * Router options for the app. `paramsInheritanceStrategy` is pinned explicitly: Angular 22 changes the
 * default from 'emptyOnly' to 'always', which would silently change which route params/data child
 * routes (e.g. under `:tenant-slug`) can see.
 */
export const appRouterConfig: RouterConfigOptions = {
    paramsInheritanceStrategy: 'emptyOnly',
};
